<template>
    <div id="container-keyboard" v-if="!isMobile()">
        <ul id="keyboard">
            <li class="symbol" @click="teclado">
                <span class="off">`</span>
                <span class="on">~</span>
            </li>
            <li class="symbol" @click="teclado">
                <span class="off">1</span>
                <span class="on">!</span>
            </li>
            <li class="symbol" @click="teclado">
                <span class="off">2</span>
                <span class="on">@</span>
            </li>
            <li class="symbol" @click="teclado">
                <span class="off">3</span>
                <span class="on">#</span>
            </li>
            <li class="symbol" @click="teclado">
                <span class="off">4</span>
                <span class="on">$</span>
            </li>
            <li class="symbol" @click="teclado">
                <span class="off">5</span>
                <span class="on">%</span>
            </li>
            <li class="symbol" @click="teclado">
                <span class="off">6</span>
                <span class="on">^</span>
            </li>
            <li class="symbol" @click="teclado">
                <span class="off">7</span>
                <span class="on">&amp;</span>
            </li>
            <li class="symbol" @click="teclado">
                <span class="off">8</span>
                <span class="on">*</span>
            </li>
            <li class="symbol" @click="teclado">
                <span class="off">9</span>
                <span class="on">(</span>
            </li>
            <li class="symbol" @click="teclado">
                <span class="off">0</span>
                <span class="on">)</span>
            </li>
            <li class="symbol" @click="teclado">
                <span class="off">-</span>
                <span class="on">_</span>
            </li>
            <li class="symbol lastitem" @click="teclado">
                <span class="off">=</span>
                <span class="on">+</span>
            </li>
            <li class="letter firstitem" @click="teclado">q</li>
            <li class="letter" @click="teclado">w</li>
            <li class="letter" @click="teclado">e</li>
            <li class="letter" @click="teclado">r</li>
            <li class="letter" @click="teclado">t</li>
            <li class="letter" @click="teclado">y</li>
            <li class="letter" @click="teclado">u</li>
            <li class="letter" @click="teclado">i</li>
            <li class="letter" @click="teclado">o</li>
            <li class="letter" @click="teclado">p</li>
            <li class="symbol" @click="teclado">
                <span class="off">[</span>
                <span class="on">{</span>
            </li>
            <li class="symbol" @click="teclado">
                <span class="off">]</span>
                <span class="on">}</span>
            </li>
            <li class="symbol lastitem" @click="teclado">
                <span class="off">\</span>
                <span class="on">|</span>
            </li>
            <li class="letter firstitem tecla-a" @click="teclado">a</li>
            <li class="letter" @click="teclado">s</li>
            <li class="letter" @click="teclado">d</li>
            <li class="letter" @click="teclado">f</li>
            <li class="letter" @click="teclado">g</li>
            <li class="letter" @click="teclado">h</li>
            <li class="letter" @click="teclado">j</li>
            <li class="letter" @click="teclado">k</li>
            <li class="letter" @click="teclado">l</li>
            <li class="symbol" @click="teclado">
                <span class="off">;</span>
                <span class="on">:</span>
            </li>
            <li class="symbol" @click="teclado">
                <span class="off">'</span>
                <span class="on">&quot;</span>
            </li>
            <li class="delete lastitem" @click="teclado">delete</li>
            <li class="left-shift" @click="teclado">shift</li>
            <li class="letter" @click="teclado">z</li>
            <li class="letter" @click="teclado">x</li>
            <li class="letter" @click="teclado">c</li>
            <li class="letter" @click="teclado">v</li>
            <li class="letter" @click="teclado">b</li>
            <li class="letter" @click="teclado">n</li>
            <li class="letter" @click="teclado">m</li>
            <li class="symbol" @click="teclado">
                <span class="off">,</span>
                <span class="on">&lt;</span>
            </li>
            <li class="symbol" @click="teclado">
                <span class="off">.</span>
                <span class="on">&gt;</span>
            </li>
            <li class="symbol lastitem" @click="teclado">
                <span class="off">/</span>
                <span class="on">?</span>
            </li>
        </ul>
    </div>
</template>

<script>	

	export default {
		methods: {
            isMobile() {
                if(/Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent)) {
                    return true
                } else {
                    return false
                }
                },
			teclado: function(event) {
                       var password = $('*[id="txtSenha"]'),
                        shift = false,
                        capslock = false;                
/*
                    $('li:focus').blur();
                    $('#keyboard li').click(function(){
                        $('li:focus').blur();*/
                        var $this = $(event.target),
                            character = $this.html(); // If it's a lowercase letter, nothing happens to this variable
                        
                        // Shift keys
                        if ($this.hasClass('left-shift') || $this.hasClass('right-shift')) {
                            $('.letter').toggleClass('uppercase');
                            $('.symbol span').toggle();
                            
                            shift = (shift === true) ? false : true;
                            capslock = false;
                            return false;
                        }
                        
                        // Caps lock
                        if ($this.hasClass('capslock')) {
                            $('.letter').toggleClass('uppercase');
                            capslock = true;
                            return false;
                        }
                        
                        // Delete
                        if ($this.hasClass('delete')) {
                            var html = password.val();
                            
                            password.val(html.substr(0, html.length - 1));
                            return false;
                        }
                        
                        // Special characters
                        if ($this.hasClass('symbol')) character = $('span:visible', $this).html();
                        if ($this.hasClass('space')) character = ' ';
                        if ($this.hasClass('tab')) character = "\t";
                        if ($this.hasClass('return')) character = "\n";
                        
                        // Uppercase letter
                        if ($this.hasClass('uppercase')) character = character.toUpperCase();
                        // Add the character
                        password.val(password.val()+character);
                   // });
                }
            }
        
    }
</script>

<style lang="scss">
	@import "../../../assets/sass/keyboard.scss";
</style>